import {Injectable} from '@angular/core';
import {Observable, Subscriber} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WorkerService {

  private worker: Worker;
  private readonly pendingMessages: Record<number, Subscriber<unknown>> = {};

  constructor() { }

  public invokeMessage(message: any): Observable<unknown> {
    return new Observable(subscriber => {
      const messageId = message.id;
      this.pendingMessages[messageId] = subscriber;
      this.worker.postMessage({message});
    });
  }

  public initialize() {
    this.worker = new Worker('assets/wasm/worker.js', {type: 'classic'});
    this.worker.onmessage = ({data}) => {
      if (data.id in this.pendingMessages) {
        if (data.status === 'success' && data.result !== undefined) {
          this.pendingMessages[data.id].next(data.result);
          this.pendingMessages[data.id].complete();
        } else if (data.status === 'update') {
          this.pendingMessages[data.id].next(data);
        } else {
          this.pendingMessages[data.id].error(data.result);
        }
      }  else {
        console.warn('Received unexpected message from worker ', data);
      }
    };

    this.worker.onerror = (e) => {
      console.log('Error in webworker ', e);
    };
  }

  public kill() {
    console.log('kill');
    this.worker.terminate();
  }

}
